import { TitleHeaderHyperlink } from "../../Cards/Utils/TitleHeaderHyperlink";
import { CardBase } from "@/components/Dashboard/UI/Cards/Utils/CardHelper";
import { useMemo } from "react";
import { AssignmentProps } from "@/interfaces/assignment_types";
import { AssignmentInnerContainer } from "./AssignmentInnerContainer";

type AssignmentOuterContainerProps = {
    projectName: string,
    assignments: AssignmentProps[],
    isNewCard: (cardType: string, id: string) => boolean,
    markAsSeen: (cardType: string, id: string) => void,
    folderLocation: string
}
// This container is the Parent of the TaskInnerContainer. It contains the project name and the tasks inside
export function AssignmentOuterContainer({ projectName, assignments, isNewCard, markAsSeen, folderLocation }: AssignmentOuterContainerProps) {
    const hasNewAssignments = useMemo(() => {
        return assignments.some((assignment) => isNewCard('assignment', assignment.id ?? ''))
    }, [assignments]);

    return (
        <CardBase
            className="mb-2 border-b border-gray-200 my-2 bg-orange-100 dark:bg-stone-800 p-2 rounded-lg"
            isNew={false}
            hoverChildren={<AssignmentInnerContainer assignments={assignments} isNewCard={isNewCard} markAsSeen={markAsSeen} />}
            maxHeight={1000}
            hoverText="Assignments"
        >
            <TitleHeaderHyperlink title={projectName} folder_location={folderLocation} />

            <div className="text-sm text-gray-500 dark:text-stone-300">
                # of Assignments: {assignments.length}
            </div>

            {hasNewAssignments && <h4 className="text-green-500 animate-pulse">New Assignments Inside!</h4>}
        </CardBase>
    );
}
